import { render, staticRenderFns } from "./tableCurrent.vue?vue&type=template&id=faf7ceca&scoped=true"
import script from "./tableCurrent.vue?vue&type=script&lang=js"
export * from "./tableCurrent.vue?vue&type=script&lang=js"
import style0 from "./tableCurrent.vue?vue&type=style&index=0&id=faf7ceca&prod&lang=css"
import style1 from "./tableCurrent.vue?vue&type=style&index=1&id=faf7ceca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf7ceca",
  null
  
)

export default component.exports